export default ['5k or less', '10k-20k', '25k-50k', '50k-100k', '100k+'];
